import { cn } from "@/lib/utils";

const COLOR_CLASSES = {
    blue: "bg-blue-50 text-blue-700 ring-blue-200",
    amber: "bg-amber-50 text-amber-700 ring-amber-200",
    orange: "bg-orange-50 text-orange-700 ring-orange-200",
    red: "bg-rose-50 text-rose-700 ring-rose-200",
    rose: "bg-rose-50 text-rose-700 ring-rose-200",
    green: "bg-emerald-50 text-emerald-700 ring-emerald-200",
    emerald: "bg-emerald-50 text-emerald-700 ring-emerald-200",
    violet: "bg-violet-50 text-violet-700 ring-violet-200",
    purple: "bg-violet-50 text-violet-700 ring-violet-200",
    slate: "bg-slate-100 text-slate-700 ring-slate-200",
    gray: "bg-gray-100 text-gray-700 ring-gray-200",
    teal: "bg-teal-50 text-teal-700 ring-teal-200",
};

export default function LeadTypePill({ leadType, className }) {
    if (!leadType) {
        return (
            <span className={cn("inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium bg-gray-50 text-gray-500 ring-1 ring-inset ring-gray-200", className)}>
                Unclassified
            </span>
        );
    }
    const klass = COLOR_CLASSES[leadType.color] || COLOR_CLASSES.blue;
    return (
        <span
            className={cn("inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium ring-1 ring-inset", klass, className)}
            data-testid={`lead-type-pill-${leadType.id}`}
        >
            {leadType.name}
        </span>
    );
}

export { COLOR_CLASSES };
